import React, { useEffect } from 'react';
import Text from '../components/Text';
import { useNavigate } from 'react-router-dom'

function Splashscreen(props) {

    const RandomTime = (min, max) => {
        return Math.floor(min + Math.random() * (max - min + 1))
    }
    let navigate = useNavigate();

    useEffect(() => {
        //Idle timer 
        let timerId;

        const resetTimer = () => {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                navigate("/login");
            }, RandomTime(300, 1200)); //30 sec idle time
        };

        document.addEventListener("keydown", resetTimer);
        document.addEventListener("mousemove", resetTimer);
        return () => {
            clearTimeout(timerId);
            document.removeEventListener("keydown", resetTimer);
            document.removeEventListener("mousemove", resetTimer);
        };
    }, [navigate]);


    return (
        <div className='w-splashscreen w-fullscreen bg-blue'>
            <img className="w-img-lg" src="/img/categories/wordin_white.png" alt="login" />
            <br />
            <Text text="Word’In progress ..." classes="w-text-white" />
        </div>
    );
}

export default Splashscreen;